import { scrollToElement } from '@diana/core';

export const scrollToStep = (stepId: string) => {
  scrollToElement({
    selector: `[data-step-id="${stepId}"]`,
    padding: 8,
    isBoundingClientRect: true,
  });
};

export const scrollToTask = (taskId: string) => {
  scrollToElement({
    selector: `[data-task-id="${taskId}"]`,
    padding: 8,
    isBoundingClientRect: true,
  });
};

export const scrollToSection = (sectionId: string) => {
  scrollToElement({
    selector: `[data-layout-component-id="${sectionId}"]`,
    padding: 60,
    isBoundingClientRect: true,
  });
};
